import { Button } from "@/src/components/ui/Button";
import { Text } from "@/src/components/ui/Typography";
import { cn } from "@/src/lib/utils";

import type { UseCaseItem } from "./UseCasesShowcase";

interface UseCaseMobileRowProps {
  number: string;
  item: UseCaseItem;
  active: boolean;
  onSelect: () => void;
}

export function UseCaseMobileRow({ number, item, active, onSelect }: UseCaseMobileRowProps) {
  return (
    <div className="border-b border-neutral-200 py-5 first:pt-0 last:border-b-0">
      <Button
        type="button"
        unstyled
        onClick={onSelect}
        aria-expanded={active}
        className="flex w-full items-baseline gap-4 text-left"
      >
        <Text
          as="span"
          size="labelMD"
          className={cn(
            "shrink-0 transition-colors duration-300",
            active ? "text-brand" : "text-neutral-400",
          )}
        >
          {number}
        </Text>

        <Text
          as="span"
          size="bodyMD"
          className={cn(
            "transition-colors duration-300",
            active ? "text-neutral-700" : "text-neutral-500",
          )}
        >
          {item.title}
        </Text>
      </Button>

      <div
        className={cn(
          "grid overflow-hidden transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]",
          active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        )}
      >
        <div className="min-h-0 overflow-hidden pt-4">
          <div className="flex flex-col gap-4 rounded-(--radius-lg) border border-neutral-200 bg-neutral-50 p-5">
            <div>
              <Text size="labelSM" className="uppercase tracking-widest text-neutral-500">
                Situation
              </Text>
              <Text size="bodySM" className="mt-1.5 text-neutral-600">
                {item.situation}
              </Text>
            </div>

            <div>
              <Text size="labelSM" className="uppercase tracking-widest text-neutral-500">
                Solution
              </Text>
              <Text size="bodySM" className="mt-1.5 text-neutral-600">
                {item.solution}
              </Text>
            </div>

            <div className="rounded-(--radius-sm) bg-white p-4">
              <Text size="labelSM" className="uppercase tracking-widest text-brand">
                Outcome
              </Text>
              <Text size="bodySMMedium" className="mt-1.5 text-neutral-700">
                {item.outcome}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
